import { useEffect, useState } from "react";
import Lottie from "lottie-react";
import background_1 from "../animations/background_1.json";
import Style from '../styles/ChangeInitialPass.module.css';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import { BiShow, BiHide, BiCheckCircle, BiErrorCircle } from "react-icons/bi";
import InputAdornment from '@mui/material/InputAdornment';
import ModifyInitialPassword from "../services/ModifyInitialPasssword";
import CheckPassword from "../services/CheckPassword";
import { decrypt, calculatePasswordStrength } from "../helpers/Helpers";
import { useNavigate } from 'react-router-dom';

const STRENGTH_STYLES = {
    weak: { label: 'Weak', color: '#dc2626', width: '25%' },
    medium: { label: 'Medium', color: '#f59e42', width: '50%' },
    strong: { label: 'Strong', color: '#2563eb', width: '75%' },
    very_strong: { label: 'Very strong', color: '#16a34a', width: '100%' },
};
const MIN_ACCEPTABLE_LEVELS = ['medium', 'strong', 'very_strong'];

function ChangeInitialPassword() {

    const [pass, setPass] = useState('');
    const [repeatPass, setRepeatPass] = useState('');
    const [currentPass, setCurrentPass] = useState('');
    const [error, setError] = useState(false);
    const [sucess, setSucess] = useState(false);
    const [errorMsg, setErrorMsg] = useState('');
    const [errors, setErrors] = useState({ pass: '', repeatPass: '' });
    const [showPass, setShowPass] = useState(false);
    const [showRepeatPass, setShowRepeatPass] = useState(false);
    const [checking, setChecking] = useState(false);
    const [policyChangeRequired, setPolicyChangeRequired] = useState(false);
    const [forcedReason, setForcedReason] = useState('');

    const navigate = useNavigate();

    const strength = pass ? calculatePasswordStrength(pass) : null;
    const strengthStyle = strength ? STRENGTH_STYLES[strength.level] : null;
    const strengthInsufficient = strength !== null && !MIN_ACCEPTABLE_LEVELS.includes(strength.level);

    useEffect(() => {
        const storedCurrentPass = decrypt(sessionStorage.getItem('current'), process.env.REACT_APP_KEY);
        if (storedCurrentPass) {
            setCurrentPass(storedCurrentPass);
        }
        if (sessionStorage.getItem('policyChangeRequired') === 'true') {
            setPolicyChangeRequired(true);
            setForcedReason(sessionStorage.getItem('forcedReason') || '');
        }
    }, []);

    useEffect(() => {
        validatePass();
    }, [pass, repeatPass]);

    const validatePass = () => {
        let passErrors = '';
        let repeatPassErrors = '';

        if (pass != '' && repeatPass != '') {
            if (pass !== repeatPass) {
                repeatPassErrors = 'Passwords do not match.';
            }
            if (pass.length < 10) {
                passErrors = 'Must be min 10 characters';
            }
            if (!/[A-Za-z]/.test(pass)) {
                passErrors = 'Must contain min one letter';
            }
            if (!/[0-9]/.test(pass)) {
                passErrors = 'Must contain min one number';
            }
            if (!/[!@#$%^&*(),.?":{}|<>]/.test(pass)) {
                passErrors = 'Must contain min one special char';
            }
            if (currentPass === pass) {
                passErrors = 'Can´t be same as current password';
            }
            if (strengthInsufficient) {
                passErrors = 'Password quality too low, add more variety';
            }
        }
        setErrors({ pass: passErrors, repeatPass: repeatPassErrors });
    };

    const toggleShowPass = () => {
        setShowPass(!showPass);
    };

    const toggleShowRepeatPass = () => {
        setShowRepeatPass(!showRepeatPass);
    };

    const handleClick = async () => {
        validatePass();
        if (!errors.pass && !errors.repeatPass) {
            setErrorMsg('');
            setChecking(true);
            const crewCode = sessionStorage.getItem('crewCode');
            const timestamp = new Date().toISOString();

            let checkResult;
            try {
                checkResult = await CheckPassword({ crewCode, password: pass, timestamp });
            } catch (e) {
                setChecking(false);
                setError(true);
                setErrorMsg('No se pudo validar la contraseña, inténtalo de nuevo');
                return;
            }
            if (!checkResult || !checkResult.success) {
                setChecking(false);
                setError(true);
                if (checkResult && checkResult.response) {
                    // Resultado de validación real (ej. "La contraseña ya fue utilizada recientemente")
                    setErrorMsg(checkResult.response);
                } else {
                    // checkResult.message (o ausencia total de respuesta) = fallo del sistema al
                    // comprobar la contraseña, no una conclusión sobre si es válida o no.
                    setErrorMsg('No se pudo comprobar la contraseña, inténtalo de nuevo');
                }
                return;
            }

            ModifyInitialPassword({
                crewCode,
                password: pass
            }).then(res => {
                setChecking(false);
                if (res.success) {
                    setSucess(true)
                    setTimeout(function () {
                        sessionStorage.clear()
                        navigate('/', { replace: true })
                    }, 5000);
                } else {
                    setError(true)
                    setErrorMsg(res.response || 'Error: try again later')
                    setTimeout(function () {
                        sessionStorage.clear()
                        navigate('/', { replace: true })
                    }, 5000);
                }
            });
        } else {
            console.log('Error:', errors);
        }
    }

    return (
        <div>
            {error &&
                <div style={{ fontSize: 'large', paddingTop: '5px', paddingBottom: '5px', position: "absolute", zIndex: '9999999999', backgroundColor: 'red', width: '100%', textAlign: 'center', color: 'white' }}>{errorMsg || 'Error: try again later'}</div>
            }
            {sucess &&
                <div style={{ fontSize: 'large', paddingTop: '5px', paddingBottom: '5px', position: "absolute", zIndex: '9999999999', backgroundColor: 'green', width: '100%', textAlign: 'center', color: 'white' }}>Success: password changed</div>
            }
            <div className={Style.ChangePassContainer}>

                <div className={Style.password_rules} style={{
                    background: 'linear-gradient(90deg, #f0f4ff 0%, #eaf6ff 100%)',
                    borderRadius: '12px',
                    padding: '18px 20px',
                    fontSize: '.6em',
                    color: '#234',
                    boxShadow: '0 2px 8px 0 #e0e8ff',
                    border: '1px solid #dbeafe',
                    maxWidth: 420,
                    marginLeft: 'auto',
                    marginRight: 'auto',
                }}>
                    <div style={{ fontWeight: 600, fontSize: '1.08em', marginBottom: 8, color: '#1e293b', letterSpacing: 0.2 }}>
                        Password requirements
                    </div>
                    <ul style={{ listStyle: 'none', margin: 0, padding: 0 }}>
                        <li style={{ display: 'flex', alignItems: 'center', marginBottom: 4 }}>
                            <BiCheckCircle style={{ color: '#2563eb', marginRight: 8 }} /> At least <b>10 characters</b>
                        </li>
                        <li style={{ display: 'flex', alignItems: 'center', marginBottom: 4 }}>
                            <BiCheckCircle style={{ color: '#2563eb', marginRight: 8 }} /> At least <b>one letter</b> (A-Z or a-z)
                        </li>
                        <li style={{ display: 'flex', alignItems: 'center', marginBottom: 4 }}>
                            <BiCheckCircle style={{ color: '#2563eb', marginRight: 8 }} /> At least <b>one number</b> (0-9)
                        </li>
                        <li style={{ display: 'flex', alignItems: 'center', marginBottom: 4 }}>
                            <BiCheckCircle style={{ color: '#2563eb', marginRight: 8 }} /> At least <b>one special character</b> <span style={{ fontFamily: 'monospace', fontSize: '0.98em' }}>(!@#$%^&amp;*(),.?":&#123;&#125;|&lt;&gt;)</span>
                        </li>
                        <li style={{ display: 'flex', alignItems: 'center' }}>
                            <BiErrorCircle style={{ color: '#f59e42', marginRight: 8 }} /> Cannot match <b>any of your last 3 passwords</b>
                        </li>
                    </ul>
                </div>
                <div className={Style.form_container}>
                    <h3 className={Style.form_title}>INSERT NEW PASSWORD</h3>
                    <div className={Style.password_container}>
                        <TextField
                            id="outlined-basic"
                            variant="outlined"
                            className={Style.textfield}
                            type={showPass ? "text" : "password"}
                            value={pass}
                            size="small"
                            placeholder="PASSWORD"
                            onChange={(e) => setPass(e.target.value)}
                            error={errors.pass != '' && Boolean(errors.pass)}
                            helperText={errors.pass}
                            autoComplete="new-password"
                            InputProps={{
                                startAdornment: (
                                    <InputAdornment position="start">
                                        <button onClick={toggleShowPass} className={Style.show_pass}>{showPass ? <BiHide className={Style.lock_icon} /> : <BiShow className={Style.lock_icon} />}</button>
                                    </InputAdornment>
                                ),
                            }}
                        />
                    </div>
                    {strength && (
                        <div style={{ maxWidth: 350, margin: '0 auto 12px auto' }}>
                            <div style={{ height: 6, borderRadius: 4, background: '#e2e8f0', overflow: 'hidden' }}>
                                <div style={{
                                    height: '100%',
                                    width: strengthStyle.width,
                                    background: strengthStyle.color,
                                    transition: 'width 0.2s ease, background 0.2s ease'
                                }} />
                            </div>
                            <div style={{ fontSize: '0.8em', marginTop: 4, color: strengthStyle.color, fontWeight: 600 }}>
                                {strengthStyle.label}
                            </div>
                        </div>
                    )}
                    <div className={Style.password_container}>
                        <TextField
                            id="outlined-basic"
                            variant="outlined"
                            className={Style.textfield}
                            type={showRepeatPass ? "text" : "password"}
                            value={repeatPass}
                            size="small"
                            onChange={(e) => setRepeatPass(e.target.value)}
                            error={repeatPass != '' && Boolean(errors.repeatPass)}
                            helperText={errors.repeatPass}
                            placeholder="REPEAT PASSWORD"
                            autoComplete="new-password"
                            InputProps={{
                                startAdornment: (
                                    <InputAdornment position="start">
                                        <button onClick={toggleShowRepeatPass} className={Style.show_pass}>{showRepeatPass ? <BiHide className={Style.lock_icon} /> : <BiShow className={Style.lock_icon} />}</button>
                                    </InputAdornment>
                                ),
                            }}
                        />
                    </div>
                    <Button
                        variant="contained"
                        color="primary"
                        onClick={handleClick}
                        disabled={Boolean(errors.pass) || Boolean(errors.repeatPass) || checking}
                    >
                        {checking ? 'Checking...' : 'Submit'}
                    </Button>
                </div>
                {policyChangeRequired &&
                    <div style={{
                        background: 'linear-gradient(90deg, #fff7ed 0%, #ffedd5 100%)',
                        border: '1px solid #fdba74',
                        borderRadius: '12px',
                        padding: '14px 20px',
                        marginLeft: 40,
                        marginRight: 40,
                        marginBottom:20,
                        maxWidth: 420,
                        display: 'flex',
                        alignItems: 'flex-start',
                        gap: 10,
                    }}>
                        <BiErrorCircle style={{ color: '#c2410c', minWidth: 20, marginTop: 2 }} />
                        <div style={{ fontSize: '.75em', color: '#7c2d12' }}>
                            <div style={{ fontWeight: 600, marginBottom: 2 }}>Password change required</div>
                            {'Your organization requires you to change your password before continuing.'}
                        </div>
                    </div>
                }
            </div>

            <Lottie
                className={Style.lottie_file}
                autoplay={false}
                loop
                animationData={background_1}
            />
        </div>
    );
}

export default ChangeInitialPassword;
